import React from 'react'
import styled from 'styled-components'
import { number, oneOfType, string } from 'prop-types'
import { navigate } from '@reach/router'
import Card from '@taglivros/oef_componentes/build/components/card'
import Button from '@taglivros/oef_componentes/build/components/button'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'
import { BOTAO_CARD_PRESENTEADO, textoCardPresenteado } from '../constantsHome'
import { INFORMACAO_MODALIDADES, URLS } from '../../../constants'
import { isEmptyObject } from '../../../utils/helpers/helpers'

const Titulo = styled.h2`
  margin: 0;
`

const Texto = styled.p`
  ${( { fontWeight } ) => fontWeight === 'bold' ? StyleGuide.boldFonte : StyleGuide.defaultFonte};
  line-height: 1.6;
  margin: ${( { margin } ) => margin || `1em 0`};
`

const CardPresenteado = ( { idModalidadePermanecer } ) => {
  const modalidadePorIdPresenteado = INFORMACAO_MODALIDADES.find( info => info.id === idModalidadePermanecer )

  if ( isEmptyObject( modalidadePorIdPresenteado ) ) {
    return <InlineLoader isCenter />
  }

  return (
    <Card
      className="card"
      largura="100%"
    >
      <Titulo>
        { textoCardPresenteado( modalidadePorIdPresenteado.titulo ).titulo }
      </Titulo>

      <Texto margin="1em 0 1.5em">
        { textoCardPresenteado( modalidadePorIdPresenteado.titulo ).descricao }
      </Texto>

      <Button
        onClick={ () => navigate( `${modalidadePorIdPresenteado.slug}/${URLS.CONTINUAR_ASSINATURA_PLANO}` ) }
        tema={ Button.BOTAO_CURADORIA }
        testId="botao-home-presenteado"
      >
        { BOTAO_CARD_PRESENTEADO }
      </Button>
    </Card>
  )
}

CardPresenteado.propTypes = {
  'idModalidadePermanecer': oneOfType( [ number, string ] ).isRequired
}

export default CardPresenteado
